<template>
  <div class="d-flex">
    <h6 class="my-auto">
      Select year:&nbsp;
    </h6>

    <div
      class="btn-group my-auto"
      role="group"
    >
      <BasicButton
        v-for="year in years"
        :key="year"
        :class="getClass(year)"
        @click="() => $emit('input', year)"
      >
        {{year}}
      </BasicButton>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  import BasicButton from '@/components/BasicButton'

  export default {
    components: {
      BasicButton,
    },

    props: {
      value: {
        type: Number,
      },
    },

    computed: {
      years() {
        const initialYear = 2019
        const currentYear = moment().year()
        const years = []

        for (let i = initialYear; i <= currentYear; i++)
          years.push(i)

        return years
      },
    },

    methods: {
      getClass(year) {
        if (year === this.value)
          return 'btn-primary'

        return 'btn-dark'
      },
    },
  }
</script>

<style>

</style>
